import { FEATURES } from '/src/features/_global/constants';

export const TEAM_AND_SHARING_PERMISSIONS = {
  [FEATURES.TEAM_AND_SHARING]: ({ capabilities }) => ({
    navigate: capabilities?.teamSettings.permissions.nav,
    edit: capabilities?.teamSettings.permissions.edit,
  }),
};
